import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axiosInstance from "../../services/axiosInstance.js";
import { getStoredValue } from "../../services/logics.js";
import { getApiBaseUrl } from "../../utils/ssoProvider";
import EmptyInboxBanner from "./EmptyInboxBanner.jsx";

const API_URL = getApiBaseUrl();

// Renders the empty-inbox warning on every authenticated screen (mounted from
// layouts/ContentLayout.jsx). It re-fetches the email accounts on each navigation, so
// the banner shows up after an account's first sync finds its inbox empty and clears
// once an email arrives, without a page reload.
const GlobalEmptyInboxBanner = () => {
  const { pathname } = useLocation();
  const isSidebarOpen = useSelector(state => state.sidebar.isOpen);
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    // Same guard as the template-conflicts fetch in ContentLayout: this store-scoped
    // endpoint 401s for storeless or not-yet-onboarded accounts.
    const storeId = getStoredValue("storeid");
    const hasStore = storeId && storeId !== "undefined" && storeId !== "null";
    const isOnboarded = getStoredValue("isonboarded") === "true";
    if (!hasStore || !isOnboarded) return;

    let isCurrent = true;
    axiosInstance
      .get(`${API_URL}/v1/store/email/accounts?is_deleted=False`)
      .then(response => {
        if (isCurrent) setAccounts(response.data);
      })
      // The banner is only a hint; a failed fetch leaves it as it was.
      .catch(() => {});
    return () => {
      isCurrent = false;
    };
  }, [pathname]);

  const hasEmptyInbox = Array.isArray(accounts) && accounts.some(account => account?.is_inbox_empty);
  if (!hasEmptyInbox) return null;

  return (
    <div
      className={`px-[10px] sm:px-5 lg:px-6 pt-3 transition-all ease-in-out duration-500 ${
        isSidebarOpen ? "lg:ml-[220px] xl:ml-[242px]" : "lg:ml-[80px]"
      }`}
    >
      <EmptyInboxBanner accounts={accounts} />
    </div>
  );
};

export default GlobalEmptyInboxBanner;
